import { CruiseItineraryFragment } from "types/graphql-types";
import { InclusionContent } from "@silversea-ssc/ui-components-react";
import { FareCode } from "@silversea-ssc/web-fares";
import { DayByDay } from "src/page-components/cruise/itinerary/day-by-day";

export enum ShorexCategory {
  IncludedInAllInclusive,
  Premium,
  MidVoyageLandAdventure
}

export type CategorisedShorex = RemoteShorex & {
  displayCategory?: ShorexCategory;
  duration: number;
  price?: number;
  hideDurationAndCode: boolean;
};

export type ShorexCode =
  | "privato"
  | "evening-excursions"
  | "new"
  | "free-shorex"
  | "meal-included"
  | "limited-space-available"
  | "world-cruise-collection"
  | "special-price";

export type RemoteShorex = {
  _id?: string;
  shorexWebCode?: string;
  name?: string;
  activityLevel?: number;
  accessibility?: string;
  features?: ShorexCode[];
  portId?: string;
  code?: string;
  category: string;
  subcategory?: string;
};

export type RemoteLandProgramme = {
  _id?: string;
  landProgrammeId?: number;
  name?: string;
  portId?: string;
  code?: string;
};

export type RemoteConfirmedExcursions = {
  portId: string;
  itineraryItem: string;
  shorexes: RemoteConfirmedShorexList;
};

type RemoteConfirmedShorexList = {
  _key: number;
  includedInAllInclusive: boolean;
  shorexWebCode: string;
  duration: number;
  price: number;
  fareCodes: readonly FareCode[];
}[];

export type RemoteConfirmedShorexPerItineraryItem = RemoteConfirmedShorexList;

export type RemoteConfirmedExcursionsPerItineraryItem = {
  confirmedShorexes: RemoteConfirmedShorexList;
};

export type RemoteGetExcursionsQueryResponse = {
  shorexes: RemoteShorex[];
  confirmedExcursions: RemoteConfirmedExcursions[];
};

export interface CruiseItineraryItemWithExcursions
  extends CruiseItineraryFragment {
  shorexes: CategorisedShorex[];
}

export type PrePostItem = DayByDay & {
  content: InclusionContent;
};
